<span *ngIf="price >=0" class="{{styleClass}}">{{ formatPrice(price) }}</span>